
import { Component, Emit, Vue ,Prop} from "vue-property-decorator";
import MapApp from "@/plugin/gis-viewer/MapAppOpenLayer";
import { IOverlayParameter, IMapContainer,IResult ,ICenterLevelParams,ICenterLevel,ILayerConfig, IOverlayClusterParameter,IOverlayDelete, IFindParameter, IHeatParameter, IDrawOverlays, ShowPartParameter, ShowPartCancelParameter} from "@/types/map";
@Component({
  name: "MapContainerOpenLayer",
})
export default class MapContainerOpenLayer extends Vue implements IMapContainer {
  // private mapConfig!: Object;
  @Prop({ type: Object }) readonly mapConfig!: any;

  private mapApp!: MapApp;
  mapId: string = "divOpenLayerMap2D" + (Math.random() * 10000).toFixed(0);
  private mapClickEvent!: any;
  private markerClickEvent!: any;
  private markerMouseEvent!: any;

  async mounted() {
    this.mapApp = new MapApp();
    this.mapApp.mapClick = this.mapClick;
    this.mapApp.mapLoaded = this.mapLoaded;

    this.mapApp.showGisDeviceInfo = this.showGisDeviceInfo;
    this.mapApp.markerMouseIn = this.makerMouseIn;
    this.mapApp.markerMouseOut = this.markerMouseOut;
    this.mapApp.mapZoom = this.mapZoom;
    this.mapApp.mouseGisDeviceInfo = this.mouseGisDeviceInfo;
    console.log("地图配置参数：");
    console.log(this.mapConfig);
    await this.mapApp.init(this.mapId, this.mapConfig);//初始化地图底图,地图容器div 地图配置参数
    this.mapLoaded();
  }

  // get view() {
  //       return this.mapApp.view;
  //   }

  // 展示图层
  public showLayer(params: ILayerConfig) {
    this.mapApp.showLayer(params);
  }
  // 隐藏图层
  public hideLayer(params: ILayerConfig) {
    this.mapApp.hideLayer(params);
  }
  // 点位聚合
  public async addOverlaysCluster(params: IOverlayClusterParameter): Promise<IResult> {
    console.log(params)
    return await this.mapApp.addOverlaysCluster(params);
  }
  // 去除点位聚合
  public deleteOverlaysCluster(params: IOverlayDelete) {
    console.log(params);
    this.mapApp.deleteOverlaysCluster(params);
  }
  // 查找定位
  public findFeature(params: IFindParameter): Promise<IResult> {
    console.log(params);
    return this.mapApp.findFeature(params);
  }
  // 热力图
  public async addHeatMap(params: IHeatParameter): Promise<IResult> {
    return this.mapApp.addHeatMap(params);
  }
  // 画点、画线、画多边形
  public async startDrawOverlays(params: IDrawOverlays): Promise<void> {
    return await this.mapApp.startDrawOverlays(params);
  }
  // 停止绘制
  public async stopDrawOverlays(): Promise<void> {
    return await this.mapApp.stopDrawOverlays();
  }
  // 获取绘制结果、获取地图上所有绘制的覆盖物结果
  public async getDrawOverlays(): Promise<IResult> {
    return await this.mapApp.getDrawOverlays();
  }
  // 删除绘制结果
  public async deleteDrawOverlays(params: IOverlayDelete): Promise<void> {
    return await this.mapApp.deleteDrawOverlays(params);
  }
  // 图层展示部分
  public async showPart(params: ShowPartParameter): Promise<void> {
    return await this.mapApp.showPart(params);
  }
  // 取消图层展示部分
  public async showPartCancel(params: ShowPartCancelParameter): Promise<void> {
    return await this.mapApp.showPartCancel(params);
  }
  // 置顶图层
  public moveLayerToTop(params: any): IResult {
    return this.mapApp.moveLayerToTop(params);
  }
  // 调整图层顺序
  public reorderLayer(params: any): IResult {
    return this.mapApp.reorderLayer(params);
  }
  // 切换地图底图
  public changeBaseLayer(params: any): IResult {
    return this.mapApp.changeBaseLayer(params);
  }

  //自定义地图加载事件
  @Emit("map-loaded")
  private mapLoaded() {
    //do nothing
    // this.mapApp.mouseGisDeviceInfo = this.mouseGisDeviceInfo;
  }
  @Emit("map-zoom")
  private mapZoom(zoom: { new: number; old: number }) {}
  
  @Emit("map-click")
  public mapClick(point: object) {}

  @Emit("marker-click")
  public showGisDeviceInfo(type: string, id: string, detail: any, label?: string) {}

  @Emit("marker-mouse")
  public mouseGisDeviceInfo(event: any, type: string, id: string, detail: any) {}

  @Emit("marker-mouseIn")
  private makerMouseIn(event: any) {
    //do something
    this.markerMouseEvent = event;
  }

  @Emit("marker-mouseOut")
  private markerMouseOut(event: any) {
    //do something
    this.markerMouseEvent = event;
  }
  //定位
  public async setMapCenterAndLevel(params: ICenterLevel): Promise<void> {
      this.mapApp.setMapCenterAndLevel(params);
  }
  //添加点位
  public async addOverlays(params: IOverlayParameter): Promise<IResult> {
      return this.mapApp.addOverlays(params);
  }
  //删除点位
  public deleteOverlays(params: IOverlayDelete): Promise<IResult> {
      return this.mapApp.deleteOverlays(params);
  }
  //删除所有点位
  public deleteAllOverlays() {
      return this.mapApp.deleteAllOverlays();
  }
}
